import createConverter from './lib/create_converter';
import CustomerMerge from 'models/customer_merge';

export default createConverter(CustomerMerge);
